import styled, { css } from 'styled-components';

export const Section = styled.section`
  width: 100%;
  padding: 140px 0;
  background-color: #7726fd;
`;

export const Container = styled.div`
  margin: auto;
  max-width: 924px;
  padding: 0 37.5px;
`;

export const Image = styled.img`
  width: 100%;
`;

const title = css`
  margin-bottom: 16px;
  color: #fff;
`;

export const Title = styled.h3`
  ${title}
`;

Title.xs = styled.h4`
  ${title}
`;

const text = css`
  margin-bottom: 40px;
  color: #fff;
`;

export const Text = styled.h5`
  ${text}
`;

Text.xs = styled.p`
  ${text}
`;
